var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top'),_c('div',{staticClass:"contentWrapper"},[_c('span',[_c('left')],1),_c('div',{staticClass:"right"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }